import type { TAppError } from './error';
import { getNow } from './date';

type LoggerArgs = {
  error: TAppError;
  type?: 'error' | 'warn' | 'info';
  date?: string;
  url?: string;
};
export function logger({ error, type = 'error', date }: LoggerArgs) {
  // aqui podemos enviar los errores a un servicio de log, propio como el de /api o algo externo.

  const dateToUse = date ?? getNow();
  console[type](
    `${dateToUse} - ${error.code}:\n${error.message}${error.url ? `\n${error.url}` : ''}${error.data ? `\n${error.data}` : ''}`,
    JSON.stringify(error),
  );
}

logger.error = function (data: Omit<LoggerArgs, 'type'>) {
  return logger({ ...data, type: 'error' });
};

logger.warn = function (data: Omit<LoggerArgs, 'type'>) {
  return logger({ ...data, type: 'warn' });
};

logger.info = function (data: Omit<LoggerArgs, 'type'>) {
  return logger({ ...data, type: 'info' });
};
